module.exports = __webpack_public_path__ + "img/12.e6252089.jpg";